import React from 'react';
import { CircularProgress, CircularProgressProps } from '@chakra-ui/react';

import { Box } from '@brand/components';

interface Props extends CircularProgressProps {
  centered?: boolean;
}

export const Loading = ({ centered, ...props }: Props): JSX.Element => {
  return (
    <Box textAlign={centered ? `center` : `left`}>
      <CircularProgress isIndeterminate color="primary.base" {...props} />
    </Box>
  );
};
export type { Props as LoadingProps };
